import React, { PureComponent } from 'react';
import FoodProfileBadge from 'apps/foodProfile/components/FoodProfileBadge';
import { SUITABILITY_EMPTY } from 'apps/foodProfile/consts';

function generateUnsuitableConditionsPartial(suitability) {
  return suitability.unsuitableConditions.length ? (
    <>
      This product contains <span className="bop-foodProfileBOPBasicInfo__allergens">
        {suitability.unsuitableConditions.join(', ')}
      </span>.
    </>
  ) : null;
}

function generateMayContainPartial(suitability) {
  return suitability.mayContainIngredients.length ? (
    <>
      contain <span className="bop-foodProfileBOPBasicInfo__allergens">
        {suitability.mayContainIngredients.join(', ')}
      </span>
    </>
  ) : null;
}

function generateJointPartial(suitability) {
  switch (true) {
    case Boolean(suitability.unsuitableConditions.length && suitability.mayContainIngredients.length): // both are defined
      return ' May ';
    case Boolean(suitability.mayContainIngredients.length): // only mayContainIngredients defined
      return 'This product may ';
    default:
      return null;
  }
}

export default class FoodProfileInfo extends PureComponent {
  render() {
    const {
      isBadgeEnabled,
      suitability = SUITABILITY_EMPTY,
    } = this.props;

    if (!isBadgeEnabled || suitability.isSuitable !== 0) return null;

    return (
      <div className="gn-content bop-foodProfileBOPBasicInfo">
        <FoodProfileBadge
          isBadgeEnabled={isBadgeEnabled}
          suitability={suitability}
        />
        {generateUnsuitableConditionsPartial(suitability)}
        {generateJointPartial(suitability)}
        {generateMayContainPartial(suitability)}
      </div>
    );
  }
}
